import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Table, Button, Card, Input, Space, Popconfirm, Spin } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, ReloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../stores/root-store-context';
import { useNavigate } from 'react-router';

const ExternalCompanyManagement: React.FC = observer(() => {
  const { t } = useTranslation();
  const { applicationStore, crmStore } = useStore();
  const navigate = useNavigate();

  const [search, setSearch] = useState<{ [k: string]: string }>({});

  useEffect(() => {
    crmStore.getExternalCompanies();
  }, [crmStore]);

  const data = crmStore.externalCompanies.filter(c => {
    const { name, edrpou } = search;
    if (name && !c.name.toLowerCase().includes(name.toLowerCase())) return false;
    if (edrpou && !c.edrpou?.includes(edrpou)) return false;
    return true;
  });

  const columns = [
    { title: '#', dataIndex: 'id', key: 'id', width: '6%' },
    { title: t('Name'), dataIndex: 'name', key: 'name', width: '28%' },
    { title: t('EDRPOU'), dataIndex: 'edrpou', key: 'edrpou', width: '18%' },
    {
      title: t('Address'),
      dataIndex: 'addresses',
      key: 'addresses',
      width: '28%',
      render: (arr: any[]) =>
        arr?.length
          ? `${arr[0].locationName || ''} ${arr[0].city || ''} ${arr[0].country || ''}`.trim()
          : '',
    },
    {
      title: t('Actions'),
      key: 'actions',
      width: '20%',
      render: (_: unknown, r: any) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            onClick={() =>
              navigate(`/${applicationStore.company?.Tenant}/crm/company/${r.id}`)
            }
          />
          <Popconfirm
            title={t('DeleteCompanyConfirm')}
            onConfirm={() => crmStore.deleteExternalCompany(r.id)}
          >
            <Button danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Spin spinning={crmStore.isLoading}>
      <Card
        extra={
          <Space>
            {['name', 'edrpou'].map(field => (
              <Input
                key={field}
                allowClear
                placeholder={t(field.charAt(0).toUpperCase() + field.slice(1))}
                onChange={e => setSearch({ ...search, [field]: e.target.value })}
                style={{ width: 140 }}
              />
            ))}
            <Button icon={<ReloadOutlined />} onClick={() => setSearch({})} />
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() =>
                navigate(`/${applicationStore.company?.Tenant}/crm/company/new`)
              }
            >
              {t('AddCompany')}
            </Button>
          </Space>
        }
      >
        <Table
          dataSource={data}
          columns={columns}
          rowKey="id"
          pagination={{ pageSize: 10 }}
        />
      </Card>
    </Spin>
  );
});

export default ExternalCompanyManagement;
